import Days from '../assets/coupons.json';
import React from 'react';

import './AppBanner.css';

const AppBanner = ({ day }) => {
    return (
        <div className="app-banner">
            <img src={Days[day].imageUrl} alt="Chicken McNuggets" className="banner-image-small" />

            <div className="banner-text">
                <p dangerouslySetInnerHTML={{ __html: Days[day].description }} />
            </div>

            <a href="https://links.mcdonaldsapps.com/v8QphbFC" className="download-button-banner">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="40" height="40" rx="20" fill="url(#paint0_linear_banner)" />
                    <path d="M15.1382 23.0735H24.8622" stroke="black" strokeOpacity="0.85" strokeWidth="1.37931" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M20.0002 12.0391V20.3149M20.0002 20.3149L22.414 17.9011M20.0002 20.3149L17.5864 17.9011" stroke="black" strokeOpacity="0.85" strokeWidth="1.03448" strokeLinecap="round" strokeLinejoin="round"/>
                    <defs>
                        <linearGradient id="paint0_linear_banner" x1="20" y1="0" x2="20" y2="40" gradientUnits="userSpaceOnUse">
                            <stop stopColor="#FFBC0D"/>
                            <stop offset="1" stopColor="#FFBC0D" stopOpacity="0.9"/>
                        </linearGradient>
                    </defs>
                </svg>
            </a>
        </div>
    );
};

export default AppBanner;



// WEBPACK FOOTER //
// ./src/components/AppBanner.js